import $ from 'jquery';
import Component from '../model/Component';
import HttpClient from "../business/HttpClient";
import Utility from "../business/Utility";
import UserManager from '../business/UserManager';
import Tracker from "../business/Tracker";

const forbiddenWords = ["allah", "allupato", "allupata", "allupate", "allupati", "ammucchiata", "ammucchiate", "anal", "anale", "anali", "anoressico", "anoressica", "ano", "ani", "arrapato", "arrapata", "arrapati", "arrapate", "arrusa", "arruso", "assatanato", "asshole", "bagascia", "bagascie", "bagassa", "baggiana", "bagnarsi", "baldracca", "baldracche", "balengo", "balle", "balusa", "batacchio", "battona", "battone", "bastardo", "bastarda", "bastardi", "bastarde", "belino", "belin", "belino", "bega", "bitch", "blow job", "bocchinara", "bocchinare", "bocchinaro", "bocchinari", "bocchino", "bocchini", "bofilo", "boiata", "bordello", "bottana", "brinca", "brucapelo", "bucaiolo", "buco", "buchi", "bullo", "bulla", "bulli", "buliccio", "buona donna", "busone", "cacca", "cacche", "caccone", "caccati in mano e prenditi a schiaffi", "caciocappella", "cadavere", "cagare", "cago", "cagata", "cagate", "cagna", "cazzimma", "cazzino", "cazzo", "cazzola", "cazzone", "cazzoni", "checca", "checche", "chiappa", "chiavo", "chiava", "chiavare", "chiavata", "ciccione", "cicciona", "ciccioni", "ciccione", "ciospo", "ciucciami", "ciuccia", "cock", "coglione", "coglioni", "cogliona", "cornuto", "cornuta", "cornute", "cornuti", "cozza", "cretino", "cretina", "cretini", "cretine", "cristo", "culattina", "culattone", "culattoni", "culo", "culone", "culona", "culi", "di merda", "diavolo", "dildo", "dio", "dirty", "ditalino", "ditalini", "duro", "eiaculazione", "escort", "fanculo", "fascista", "fascisti", "fava", "fica", "fiche", "figa", "figazza", "fighe", "figlio di buona donna", "figlio di puttana", "figone", "finocchio", "fottere", "fottona", "fottersi", "fottiti", "fotto", "fotti", "fracicone", "fregna", "frocio", "froci", "frocione", "froscio", "fuck", "fucker", "fucking", "gesu", "ges", "gnocca", "goldone", "grasso", "grassa", "grassi", "grasse", "grassone", "grassoni", "grilletto", "guanto", "guardone", "ignorante", "ingnoranti", "imbecille", "imbecilli", "immigrati", "immigrato", "incazzarsi", "incazzati", "incazzo", "incoglionirsi", "inculare", "inculo", "incula", "ingoio", "ingoia", "isis", "islam", "islamico", "l'arte bolognese", "leccaculo", "lecchino", "lesbica", "lesbiche", "lecca", "leccamelo", "leccamela", "leccami", "lecco", "leccaciuffo", "limonare", "lofare", "loffa", "loffare", "lumaca", "lurida", "lurido", "madonna", "maiala", "maiale", "maiali", "maialona", "maialoni", "manico", "mannaggia", "maometto", "matello", "merda", "merde", "merda secca", "meretrice", "merdaccia", "merdata", "merdina", "merdone", "merdoso", "mierda", "milf", "milfone", "milfona", "mignotta", "mignotte", "mignottone", "minchia", "minchione", "minnaÊ", "minne", "mona", "monta", "monto", "montare", "mussa", "nave scuola", "nerchia", "negro", "negra", "negri", "negre", "negrone", "negroni", "nuda", "nudi", "nudo", "nude", "olio di palma", "palma", "obesa", "obesi", "obese", "obeso", "orgia", "orgie", "padulo", "palle", "palloso", "passera", "passerina", "patacca", "patata", "patonza", "pecorina", "pedofilo", "pedofilia", "pelosa", "peloso", "pelose", "pelo", "peli", "pene", "peni", "pesce", "picio", "piglianculo", "piglia in culo", "pincare", "pipa", "pipi", "pip“", "pippa", "pippone", "pirla", "pisciare", "piscio", "pisci", "pisello", "piselli", "pistola", "pistolotto", "pomiciare", "pompa", "pompino", "pompinara", "poppe", "porca", "porca madonna", "porca miseria", "porca puttana", "porco", "porcona", "porcone", "porco zio", "potta", "puppami", "puta", "puttana", "puttanone", "puttane", "puttaniere", "preservativo", "profilattico", "profilattici", "preservativi", "prostituta", "prostitute", "quaglia", "randello", "recchione", "ricchione", "ricchioni", "rincoglionire", "rincoglionita", "rincoglionito", "rizzarsi", "rizza", "rizzacazzi", "rompiballe", "rottoinculo", "ruffiano", "rumenta", "salciccia", "satana", "sbattere", "sbattersi", "sbattimi", "sborra", "sboro", "sborare", "sborrata", "sborrone", "sbrodolata", "scopare", "scopiamo", "scopo", "scopi", "scopa", "scopata", "scorreggiare", "scorreggia", "scoreggio", "scorreggione", "scorreggiona", "sega", "seghe", "sesso", "sessuale", "sessuali", "sfigato", "sfigata", "sfigati", "sfigate", "slinguare", "slinguata", "slut", "smandrappata", "soccia", "socmel", "sorca", "sgualdrina", "sgualdrine", "spagnola", "sperma", "spermicida", "spompinare", "spompino", "spompini", "spompina", "sticchio", "stronzi ", "stupido", "stupida", "stupidi", "stupide", "stronza", "stronze", "stronzata", "stronzate", "stronzo", "suca", "succhiami", "succhia", "sveltina", "sverginare", "svergare", "svergo", "tarzanello", "terrone", "terroni", "terrorista", "terroristi", "testa di cazzo", "testicolo", "testicoli", "tetta", "tette", "tettina", "tettine", "tettona", "tettone", "topa", "transessuale", "travone", "troia", "troie", "troione", "troiona", "trombare", "trombo", "tromba", "uccello", "vacca", "vaccaputtana", "vaccatroia", "vacche", "vaffanculo", "vagina", "vagine", "vangare", "verga", "vergine", "vergini", "viadone", "viadoni", "vibratore", "vibratori", "viados", "zinna", "zinne", "zio cantante", "zoccola", "zoccolone", "zoticone"]


class CommentComponent extends Component {

	constructor(element, parentCtrl) {
		super(element, parentCtrl);

        this.init();
	}

	init() {
        this.page = 1;
        this.dataset = this.buildDataset(this.element.dataset);

        this.addCommentButton = $(this.element).find("#sendComment");

        this.addCommentButton.on("click", () => {
            this.addCommentClicked();
        });

        this.loader = $(this.element).find('.loader')[0];
        this.moreBtn = $(this.element).find('.comments-board-more')[0];

        $(this.moreBtn).hide();

        this.moreBtn.addEventListener('click', () => {
            this.page++;
            this.getComments(false);
        });

        this.commentField = $(this.element).find("[name='comment']");

        this.commentField.on("change paste keyup", (event)=> {
            let element = $(event.currentTarget);
            let validity = $(element).val().trim().length > 0;
            this.addCommentButton.toggleClass("disabled",!validity);
        });

        this.commentList = $(this.element).find(".comments");
        this.commentList.html('');

        // $(this.loader).show();
        this.getComments(true);
	}

    buildDataset(dataset) {
        const d = {};

        d.key = dataset.key ? dataset.key : null;
        d.pageSize = dataset.pageSize ? parseInt(dataset.pageSize) : 10;
        d.category = dataset.category ? dataset.category : "RECIPE_COMMENTS";
        d.enablePagination = !!dataset.enablePagination ? dataset.enablePagination : true;

        return d;
    }

    addCommentClicked(){
        this.user = null;
        this.addCommentButton.toggleClass("disabled",true);
        UserManager.getLoggedUser().then((d) => {
            this.user = d;
            console.log("🍺Found logged user :");
            console.log(d);

            this.src =`<svg><use xlink:href="#svg_circle_profile"/></svg>`;
            UserManager.getAvatar(this.user.UID).then((dd) => {
                this.src = `<img src="${dd.body.path}" class="img">`;

            });

            //controllo parole vietate
            let text = $(this.element).find("#commentText").val();
            if (this.isValidText(text) && !this.isEmpty(text)) {
                //aggiungere commento alla lista
                return new Promise((resolve, reject) => {
                    HttpClient.doCall({
                        method: 'POST',
                        url: API_ENDPOINT + `/api/1.0/plugin/comments/${this.dataset.category}/${this.dataset.key}`,
                        dataType: "json",
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify({
                            "text": text,
                            "keyDesc": window.location.href
                        })
                    }).then((data) => {

                        this.commentList.html(`<div id="${data.body.id}" class="comment-row">
                                <div class="comment-avatar">
                                    ${this.src}
                                    <div class="right-text">
                                        <p class="user"><a href="/area-riservata">${this.user.profile.firstName}</a></p>
                                        <div class="date">
                                            <p class="user publish-time">Meno di un minuto fa</p>
                                        </div>
                                    </div>
                                    <div class="right-text">
                                        <p class="waiting-for">In attesa di approvazione</p>
                                    </div>
                                </div>
                                <div class="comment-text">
                                    <p>${data.body.comment}</p>
                                </div>
                            </div>` + this.comments);

                        $(this.element).find("#commentText").val("");

                        //Hybris Tracking
                        Tracker.send("EVENT", {
                            interactionType: "ZRECIPE_COMMENT",
                            productCode: $('#mb-product-externalid').text(),
                            name: $('#mb-editorialrecipe-name').text()
                        });

                        Tracker.send('EVENT', trackingParams);

                        resolve();
                    }, (error) => {
                        console.log(error);
                        this.addCommentButton.toggleClass("disabled",false);
                        reject(error);
                    });
                }, (error) => {
                    console.log(error);
                    this.addCommentButton.toggleClass("disabled",false);
                    reject(error);
                });


            } else {
                //modale parole vietate
                let modalTmpl = `<div class="modal-window" component="ModalComponent"  data-type="standard" 
					data-show-on-creation="true" 
					data-destroy-on-close="true"
             		data-tmpl-title="Attenzione!"
             		data-tmpl-subtitle="Il tuo commento contiene delle parole vietate."></div>`

                $(this.element).append(modalTmpl);
                this.loadChildComponents(this);
            }

        }, () => {
            console.log("🤹‍ No user present");
            var href = "/login?urlBack=" + Utility.getCurrentUri();
            window.location.href = href;
        });
    }


	getComments(checkForNull) {
        if (this.page == 1) {
            this.comments = ``;
        }
        $(this.moreBtn).hide();
        $(this.loader).show();
        return new Promise((resolve, reject) => {
            HttpClient.doCall({
                method: 'GET',
                url: API_ENDPOINT + `/api/1.0/plugin/comments/${this.dataset.category}/${this.dataset.key}/${this.page}/${this.dataset.pageSize}`,
                dataType: "json",
                contentType: "application/json; charset=utf-8"
            }).then((data) => {
                if (data.body !== null && typeof data.body.commentList !== 'undefined' && data.body.commentList !== null && data.body.commentList.length > 0) {
                    data.body.commentList.forEach((c) => {
                        let src = `<svg>
                                    <use xlink:href="#svg_circle_profile"/>
                                </svg>`;
                        let nickname = "Anonimo";
                        let userUrl = "javascript:void(0)";
                        if (c.user !== null) {
                            if (c.user.avatar !== null) {
                                src = `<img src="${c.user.avatar}" class="img">`;
                            }
                            if (c.user.nickname !== null) {
                                nickname = c.user.nickname;
                            }
                            // if (c.user.id !== null) {
                            //     userUrl = "/utente/"+c.user.id+"/index.html";
                            // }
                        }

                        this.comments += `<div id="${c.id}" class="comment-row">
                            <div class="comment-avatar">
                                ${src}
                                <div class="right-text">
                                    <p class="user"><a href="${userUrl}">${nickname}</a></p>
                                    <div class="date">
                                        <p class="user publish-time">${this.printDate(c.creationDate)}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="comment-text">
                                <p>${c.comment}</p>
                            </div>
                        </div>`;
                    });

                    if(data.body.commentList.length >= 1){
                        $(this.moreBtn).hide();
                        this.commentList.html(this.comments);

                        if(data.body.commentList.length === this.dataset.pageSize) {
                            if (this.dataset.enablePagination) {
                                $(this.moreBtn).show();
                            }
                        }
                    }
                } else if (checkForNull) {
                    // const text = 'Nessuno ha ancora scritto un commento, vuoi essere tu il primo a farlo?';
                    //
                    // this.commentList.html(`
					// 	<div class="empty-board">
					// 		<h4>${text}</h4>
					// 	</div>
					// `);
                }

                $(this.loader).hide();

                resolve(this.comments);

            }, (error) => {
                console.log(error);
                reject(error);
            });
        }, (error) => {
            console.log(error);
            reject(error);
        });

	}

    printDate(epocTimeStamp){
        let date = new Date(epocTimeStamp);

        let monthName=date.toLocaleString("it-IT", {month: "long"});
        return date.toLocaleString("it-IT", {day:"numeric"}) +" "+monthName.toUpperCase()+" "+date.toLocaleString("it-IT", {year:"numeric"});
    }

    isEmpty(str){
        return (!str || 0 === str.length);
    }

    isValidText(string) {
        if (string && string.length > 1) {
            string = string.trim();
            string = string.replace(/[^\w\s]|_/g, "");
            let split = string.split(" ");

            for(var i = 0; i < split.length; i++) {
                for(var j = 0; j < forbiddenWords.length; j++) {
                    if(split[i].toLowerCase() === forbiddenWords[j]) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
}

export default CommentComponent;
